import { render, staticRenderFns } from "./ContextsWrapper.vue?vue&type=template&id=4ac6b794&scoped=true"
import script from "./ContextsWrapper.vue?vue&type=script&lang=js"
export * from "./ContextsWrapper.vue?vue&type=script&lang=js"
import style0 from "./ContextsWrapper.vue?vue&type=style&index=0&id=4ac6b794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6b794",
  null
  
)

export default component.exports